import constate from 'constate';
import {
  type FunctionComponent,
  type MutableRefObject,
  type PropsWithChildren,
  useRef,
} from 'react';

export enum FinishCapturingAction {
  VIEW_INFO_PAGE = 'VIEW_INFO_PAGE',
  EDIT = 'EDIT',
}

function useFinishCapturingActions() {
  const targetWorkspaceId = useRef('');
  const tourSubmitAction = useRef(FinishCapturingAction.EDIT);

  const setTargetWorkspaceId = (id: string) => (targetWorkspaceId.current = id);
  const setTourSubmitAction = (action: FinishCapturingAction) =>
    (tourSubmitAction.current = action);

  return {
    targetWorkspaceId,
    setTargetWorkspaceId,
    tourSubmitAction,
    setTourSubmitAction,
  };
}

export const [
  FinishCapturingActionsProvider,
  useFinishCapturingActionsContext,
]: [
  FunctionComponent<PropsWithChildren>,
  () => {
    targetWorkspaceId: MutableRefObject<string>;
    setTargetWorkspaceId: (id: string) => string;
    tourSubmitAction: MutableRefObject<FinishCapturingAction>;
    setTourSubmitAction: (
      action: FinishCapturingAction
    ) => FinishCapturingAction;
  },
] = constate(useFinishCapturingActions);
